import Vue from 'vue'
import Vuex from 'vuex'

import sessao from './modules/sessao'
import funcionario from './modules/funcionario'
import contorlePonto from './modules/controlePonto'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: { sessao, funcionario, contorlePonto }
})